import { CircularProgress } from '@material-ui/core';
import { PlatformRole } from '@mogul/api-client';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import { useAuth } from '../../../auth';
import { createBuyStarsModal } from '../../../components/buy-stars-modal/BuyStarsModal';
import { OkModal } from '../../../components/common/modal/OkModal.component';
import { FarmingComponent } from '../../../components/farming/Farming.component';
import {
  Button,
  Colors,
} from '../../../components/legacy/button/Button.component';
import { ModalStateContext } from '../../../contexts/app-state-context/modal-state.context';
import { useWeb3State } from '../../../hooks';
import { WEB3_CONFIG } from '../../../lib';
import styles from './FarmingPage.module.css';

export const FarmingPage: React.FC = () => {
  const { walletDetails, isInitialized } = useWeb3State();
  const { authenticated, user } = useAuth();
  const { setModal } = useContext(ModalStateContext);

  const history = useHistory();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isInitialized) {
      return;
    }

    setLoading(false);
  }, [isInitialized]);

  const handleBuyMoreStars = (lpTokenAddress: string) => {
    const isEth = walletDetails.chain.id === WEB3_CONFIG.chains.eth.id;
    const starsAddress = WEB3_CONFIG.contracts[walletDetails.chain.key].stars;

    if (!authenticated) {
      setModal(
        OkModal('Please login to access staking.', () => {
          history.push('/login');
        }),
      );
    } else if (isEth) {
      setModal(OkModal('You must be on MAINNET to buy stars'));
    } else if (lpTokenAddress !== starsAddress) {
      setModal(OkModal('Coming Soon!'));
    } else {
      setModal(createBuyStarsModal());
    }
  };

  if (loading) {
    return (
      <div
        className={
          styles.farmPageContainer +
          ' flex flex-col justify-center px-16 h-full'
        }
      >
        <CircularProgress
          className={'grid place-items-center w-full h-full text-white'}
          size={100}
        />
      </div>
    );
  }

  return user?.role === PlatformRole.Admin ? (
    <div className={styles.farmPageContainer}>
      <h1>Admin Options</h1>
      <div className={styles.adminContainer}>
        <Button color={Colors.COLOR_SCHEME_2} className={styles.adminOptions}>
          Disable Staking
        </Button>
        <Button color={Colors.COLOR_SCHEME_2} className={styles.adminOptions}>
          Enable Staking
        </Button>
      </div>
      <FarmingComponent
        isLoggedIn={authenticated}
        handleBuyMoreStars={handleBuyMoreStars}
        chainId={walletDetails.chain.id}
      />
    </div>
  ) : (
    <FarmingComponent
      isLoggedIn={authenticated}
      handleBuyMoreStars={handleBuyMoreStars}
      chainId={walletDetails.chain.id}
    />
  );
};
